var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.toggleWishlist}},[_c('i',{class:{
        'fas fa-heart fa-lg': _vm.inWishlist,
        'far fa-heart fa-lg': !_vm.inWishlist,
      },staticStyle:{"color":"#e1236f"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }